import { createStore } from "redux";
import rootReducer from "../../legacy/reducers";
import { questionnaireSubject$ } from "../../legacy/stores/questionnaireSubject";
import { subscribeToQuestionnairePersist } from "./questionnaire-persist";

export { subscribeToQuestionnairePersist } from "./questionnaire-persist";

const isDevelopmentMode = process.env.BUILD_MODE === "development";

const devToolsConfig = {
  trace: true,
  traceLimit: 25,
};

const store = createStore(
  rootReducer,
  isDevelopmentMode ? window.__REDUX_DEVTOOLS_EXTENSION__?.(devToolsConfig) : undefined
);

subscribeToQuestionnairePersist(questionnaireSubject$);

store.subscribe(function onSetQuestionnaire() {
  const currentState = store.getState().updates;

  questionnaireSubject$.next(currentState);
});

export default store;
